export const getSampleRate = (value: number): number => {
  if (process.env.DEBUG_SENTRY) {
    console.log(`Overwriting Sentry sample rate from ${value} to 1.0`);
  }
  return process.env.APP_ENVIRONMENT === 'uat' || process.env.DEBUG_SENTRY === '1' ? 1.0 : value;
};
